import { useApp } from '@tldraw/editor'
import { useEffect, useState } from 'react'
import { useActions } from '../../hooks'
import { Button } from '../primitives'

export function BackToContent() {
	const app = useApp()

	const actions = useActions()
	const action = actions['back-to-content']

	const [showBackToContent, setShowBackToContent] = useState(false)

	useEffect(() => {
		let showBackToContentPrev = false

		const interval = setInterval(() => {
			const { renderingShapes } = app

			const showBackToContentNow = renderingShapes.length === 0 && app.shapesArray.length > 0
			if (showBackToContentPrev !== showBackToContentNow) {
				setShowBackToContent(showBackToContentNow)
				showBackToContentPrev = showBackToContentNow
			}
		}, 1000)

		return () => {
			clearInterval(interval)
		}
	}, [app])

	if (!showBackToContent) return null

	return (
		<Button
			iconLeft={action.icon}
			label={action.label}
			onClick={() => {
				action.onSelect()
				setShowBackToContent(false)
			}}
		/>
	)
}
